@if (errorExplanation()?.length) {
  <div class="error-container">
    <div id="login-error" class="login-error">
      <h3 class="error-title"><mat-icon [inline]="true">error_outline</mat-icon> {{ 'Login Error' | translate: locale.language }}</h3>
      <div>{{ errorExplanation() }}</div>
      @if (errorDetails()?.length) {
        <div id="error-text">{{ errorDetails() }}</div>
      }
      <button mat-raised-button color="primary" (click)="navigateToRoot()">{{ 'Try Again' | translate: locale.language }}</button>
    </div>
  </div>
}
